export default {
    getBatteryLevelIcon: (batteryLevel, charging) => {
        var roundedBatteryLevel = Math.round(batteryLevel / 10) * 10;
        switch(roundedBatteryLevel) {
          case  100:
            return charging ? 'mdi-battery-charging' : 'mdi-battery' ;
          case 0:
            return charging ? 'mdi-battery-charging-outline' : 'mdi-battery-alert-variant-outline';
          default:
            return charging ? `mdi-battery-charging-${roundedBatteryLevel}` : `mdi-battery-${roundedBatteryLevel}`;
        }
    },
    getBatteryLevelColor: (batteryLevel) => {
        if(batteryLevel > 50) {
            return 'green';
          }
          else if(batteryLevel > 20) {
            return 'yellow';
          }
          else {
            return 'red';
          }
    },
    getSupplyLevelColor: (supplyLevel) => {
        if(supplyLevel > 50) {
            return 'green';
          }
          else if(supplyLevel > 20) {
            return 'yellow';
          }
          else {
            return 'red';
          }
    }
}